import { useContext } from 'react'
import { CustomersContext } from 'contexts'

export const useCustomers = () => {
  const { state, dispatch } = useContext(CustomersContext)

  return {
    customers: state.customersList,
    customersContext: state,
    lastApiReceiveAt: state.loadingState.lastApiReceiveAt,
    dispatch,
  }
}
